// extracted by mini-css-extract-plugin
export default {"hoverContainerCustom":"GameViewCustomHover__hoverContainerCustom--1Sx"};